import type { Transition } from "motion/react";

/**
 * The one spring the pill animates on: its arrival at the bottom of the window, its growth into
 * a drop target, and the target's own entrance. A single curve across the three is what makes
 * them read as one movement rather than as three components that happen to animate.
 */
export const DROPZONE_SPRING: Transition = {
	type: "spring",
	stiffness: 420,
	damping: 34,
	mass: 0.8,
};
